<template>
  <div>
    <div class="head">
      <el-button type="primary"
                 @click="addItem"
                 size="small"
      >添加商品</el-button>
    </div>
    <el-dialog :visible="dialogFormVisible" :destroy-on-close="true" title="添加商品">
      <el-form :model="form" ref="form" :rules="formRules">
        <el-form-item prop="type" label="类型">
          <el-select v-model="form.type">
            <el-option value="r" label="会员" />
            <el-option value="uc" label="会员卡" />
          </el-select>
        </el-form-item>
        <el-form-item prop="name" label="名称">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item prop="start_time" label="开始时间">
          <el-date-picker v-model="form.start_time" type="datetime" />
        </el-form-item>
        <el-form-item prop="expire_time" label="结束时间">
          <el-date-picker v-model="form.expire_time" type="datetime" />
        </el-form-item>
        <el-form-item prop="original_price" label="原始价格">
          <el-input-number v-model="form.original_price" :precision="2" />
        </el-form-item>
        <el-form-item prop="final_price" label="渠道价格">
          <el-input-number v-model="form.final_price" :precision="2" />
        </el-form-item>
        <el-form-item prop="category.member_second" label="会员时长(天)">
          <el-input-number v-model="form.category.member_second" />
        </el-form-item>
        <el-form-item prop="category.level" label="会员代码">
          <el-select v-model="form.category.level">
            <el-option :value="1" label="代码: 1"></el-option>
            <el-option :value="2" label="代码: 2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="channel_rate" label="返利比例 %">
          <el-input-number v-model="form.channel_rate" :precision="2" :step="1" :max="100" />
        </el-form-item>
        <el-form-item prop="user_qty" label="单用户购买数量">
          <el-input-number v-model="form.user_qty" />
        </el-form-item>
        <el-form-item prop="sale_info.sale_title" label="展示标题">
          <el-input v-model="form.sale_info.sale_title" />
        </el-form-item>
        <el-form-item prop="sale_info.sale_desc" label="展示简介">
          <el-input v-model="form.sale_info.sale_desc" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmitForm">确 定</el-button>
      </div>
    </el-dialog>
    <el-table :data="dataList">
      <el-table-column prop="id"
                       label="ID"
      />
      <el-table-column prop="name" label="名称" />
      <el-table-column prop="start_time" label="开始时间" />
      <el-table-column prop="expire_time" label="结束时间" />
      <el-table-column prop="original_price" label="原始价格(元)">
        <template slot-scope="s">
          {{s.row.original_price / 100}}
        </template>
      </el-table-column>
      <el-table-column prop="final_price" label="渠道价格(元)">
        <template slot-scope="s">
          {{s.row.final_price / 100}}
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型">
        <template slot-scope="scope">
          {{scope.row.type === 'r' ? '会员' : '会员卡'}}
        </template>
      </el-table-column>
      <el-table-column prop="category.member_second" label="会员时长">
        <template slot-scope="scope">
          {{scope.row.category.member_second / 86400}} 天
        </template>
      </el-table-column>
      <el-table-column prop="category.level" label="会员代码" />
      <el-table-column prop="channel_rate" label="返利比例">
        <template slot-scope="scope">
          {{(scope.row.channel_rate * 100).toFixed(2)}} %
        </template>
      </el-table-column>
      <el-table-column prop="user_qty" label="限购数量" />
      <el-table-column prop="seat" label="排序" width="120px">
        <template slot-scope="scope">
          <el-input-number style="width: 100px" 
                           size="small"
                           controls-position="right"
                           @change="handleChangeSeat(scope.row, $event)"
                           :value="scope.row.seat" 
                           :min="0"
                           :max="10"
          />
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <el-switch v-if="scope.row.status !== 900" :value="scope.row.status === 100" @change="handleChangeStatus(scope.row)" />
        </template>
      </el-table-column>
    </el-table>
    <pager ref="pager" api="item_setting_list" model="shop" :params="getRequestParams" @data-changed="onDataChanged" />
  </div>
</template>
<script>
  import Pager from "../ui/Pager"
  import request from '../../api/request'
  import { format } from "date-fns";

  export default {
    name: 'ShopChannelItemList',
    components: { Pager },
    data() {
      return {
        channel: 0,
        dialogFormVisible: false,
        form: {
          type: '',
          name: '',
          start_time: '',
          expire_time: '',
          original_price: 0,
          final_price: 0,
          seat: 0,
          channel: 0,
          category: {
            member_second: 0,
            level: '',
          },
          sale_info: {
            sale_title: '',
            sale_desc: '',
          },
          channel_rate: 0,
          user_qty: 0,
          
        },
        formRules: {
          type: [
            {
              required: true,
              message: '不能为空',
            }
          ],
          name: [
            {
              required: true,
              message: '不能为空',
            }
          ],
          start_time: [
            {
              required: true,
              message: '不能为空',
            }
          ],
          expire_time: [
            {
              required: true,
              message: '不能为空',
            }
          ],
          original_price: [
            {
              required: true,
              message: '不能为空',
            },
            {
              validator: (rule, value, callback) => {
                if (value > 0) {
                  callback()
                } else {
                  callback(new Error('必须大于0'))
                }
              },
              trigger: 'blur'
            }
          ],
          final_price: [
            {
              required: true,
              message: '不能为空',
            },
            {
              validator: (rule, value, callback) => {
                if (value > 0) {
                  callback()
                } else {
                  callback(new Error('必须大于0'))
                }
              },
              trigger: 'blur'
            }
          ],
          'category.member_second': [
            {
              required: true,
              message: '不能为空',
            },
            {
              validator: (rule, value, callback) => {
                if (value > 0) {
                  callback()
                } else {
                  callback(new Error('必须大于0'))
                }
              },
              trigger: 'blur'
            }
          ],
          'category.level': [
            {
              required: true,
              message: '不能为空',
            }
          ],
          channel_rate: [
            {
              required: true,
              message: '不能为空',
            },
            {
              validator: (rule, value, callback) => {
                if (value >= 0) {
                  callback()
                } else {
                  callback(new Error('必须大于等于0'))
                }
              },
              trigger: 'blur'
            }
          ],
          'sale_info.sale_title': [
            {
              required: true,
              message: '不能为空',
            }
          ],
          'sale_info.sale_desc': [
            {
              required: true,
              message: '不能为空',
            }
          ],
          user_qty: []
        },
        dataList: []
      }
    },
    created() {
      this.channel = parseInt(this.$route.params['channel'])
    },
    computed: {
      getRequestParams() {
        return {
          filter: {
            channel: this.channel
          },
          sort: [
            {
              field: 'seat',
              reverse: true,
            }
          ]
        }
      }
    },
    methods: {
      onDataChanged(data) {
        this.dataList = data
      },
      addItem() {
        this.dialogFormVisible = true
      },
      handleSubmitForm() {
        this.$refs['form'].validate(async valid => {
          if (valid) {
            let req = {
              type: this.form.type,
              name: this.form.name,
              start_time: format(this.form.start_time, "yyyy-MM-dd HH:mm:ss"),
              expire_time: format(this.form.expire_time, "yyyy-MM-dd HH:mm:ss"),
              original_price: Math.round(this.form.original_price * 100),
              final_price: Math.round(this.form.final_price * 100),
              seat: 0,
              channel: this.channel,
              category: {
                member_second: this.form.category.member_second * 86400,
                level: parseInt(this.form.category.level),
              },
              channel_rate: this.form.channel_rate / 100,
              sale_info: this.form.sale_info
            }
            if (this.form.user_qty) {
              req.user_qty = this.form.user_qty
            }
            await request.shop.post('item_setting_create', req)
            this.$message({
              message: '创建成功',
              type: 'success'
            })
            this.dialogFormVisible = false
            this.$refs['form'].resetFields()
            this.$refs['pager'].loadData()
          } else {
            this.$message({
              message: '信息填写错误',
              type: 'error'
            })
          }
        })
      },
      async handleChangeStatus(row) {
        const status = row.status === 100 ? 900 : 100
        await request.shop.post('item_setting_update', {
          setting_id: row.id,
          status: status
        })
        this.dataList = this.dataList.map(item => {
          if (item.id === row.id) {
            item.status = status
          }
          return item
        })
      },
      async handleChangeSeat(row, value) {
        console.log(row, value)
        await request.shop.post('item_setting_seat_update', {
          setting_id: row.id,
          seat: value
        })
        this.dataList = this.dataList.map((item) => {
          if (item.id === row.id) {
            item.seat = value
          }
          return item
        })
      }
    }
  }
</script>
